import { render, staticRenderFns } from "./ThankYouMessagePreview.vue?vue&type=template&id=31ea40ce&scoped=true&"
import script from "./ThankYouMessagePreview.vue?vue&type=script&lang=js&"
export * from "./ThankYouMessagePreview.vue?vue&type=script&lang=js&"
import style0 from "./ThankYouMessagePreview.vue?vue&type=style&index=0&id=31ea40ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea40ce",
  null
  
)

export default component.exports